module.exports = function() {
  return new Worker(__webpack_public_path__ + "c77b09c6617e742038f1.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./src/workers/landscape.js
// module id = 142
// module chunks = 0